import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for casino report view.
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable for displaying casino report details.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'TransactionId', // Transaction ID column
                    header: _('Transacción ID'), // Localized header
                    width: 300, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount', // Amount column
                    header: _('Valor'), // Localized header
                    width: 100, // Column width
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for item click
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with item
                },
            },
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetailLeague',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('league', true); // Get current user league parameter
        var url = grid.data.url; // Store grid URL
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&LeagueId=' + cur_user; // Add current user league ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID change
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load data for specific user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Attach click event to grid items
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with item
        });
    }
}

// FILE DOCUMENTED
